const stagingEnv = {
    name : "staging",
    API_URL : "https://api.leanstack.co",
    CUSTOMER_URL : "https://production-user.leanstack.co"
}
export default stagingEnv